import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';
import ParkingController from './controllers/parking-controller';
import LeafletMapsController from "./controllers/leaflet-maps-controller";
import SelectController from "./controllers/select-controller";

require('./navigation');
require('./lightbox');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('cookie-bar', CookieBarController);
application.register('modal', ModalController);
application.register('tab', TabController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('parking', ParkingController);
application.register('leaflet', LeafletMapsController);
application.register('select', SelectController);
